// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ru from './locales/ru.json';
import ua from './locales/ua.json';
import ko from './locales/ko.json';
import fr from './locales/fr.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ru: { translation: ru },
            ua: { translation: ua },
            ko: { translation: ko },
            fr: { translation: fr },
        },
        fallbackLng: 'en',
        load: 'languageOnly',
        nonExplicitSupportedLngs: true,
        supportedLngs: ['en','ru','ua','ko','fr','uk'],
        interpolation: {
            escapeValue: false
        },
    });

i18n.on('languageChanged', (lng) => {
    const shortLng = lng.includes('-') ? lng.split('-')[0] : lng;
    if (lng !== shortLng) {
        i18n.changeLanguage(shortLng);
    }
});

export default i18n;
